import { transformValues } from './transformValues';
import { transformAddresses } from './transformAddresses';
import { buildPayload } from '../../../../../shared/lib/buildPayload';

export const transformFormValues = (formValues) => {
  const { addresses, initiators, mainInitiator, ...restValues } = formValues;
  const values = transformValues({
    ...restValues,
  });

  const inits = {
    initiators: initiators.map((item) => ({
      id: item,
      isMain: item === mainInitiator ? 1 : 0,
    })),
  };

  // const transformedAddresses = transformAddresses(addresses);
  const transformedAddresses = buildPayload(addresses);

  return {
    ...values,
    ...inits,
    addresses: { ...transformedAddresses },
  };
};

export { transformAddresses };
